<template>
  <div class="doctor-selector">
    <v-select :id="id" class="wabident-selector" :options="doctors" :value="value" @input="onInput"
      :reduce="x => x.value" :placeholder="placeholder"></v-select>
    <label :for="id" class="wabident-info">{{ label }}</label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
    },
    value: {
      required: true,
    },
    label: {
      default: 'Doctor'
    },
    placeholder: {
      default: 'Elige profesional',
    },
  },
  computed: {
    doctors() {
      if (!this.clinic) {
        return [];
      }

      return this.clinic.doctors.map((d) => {
        return {
          label: d.name,
          value: Number(d.doctor.id),
        }
      });
    },
    ...mapGetters(['clinic'])
  },
  methods: {
    onInput(v) {
      this.$emit('input', v);
    },
  }
}
</script>
